// ** React Imports
import { createContext, useEffect, useState } from 'react'

// ** Next Import
import { useNavigate } from 'react-router-dom'


// ** Axios
import axios from 'axios'

// ** Defaults
const defaultProvider = {
  user: null,
  loading: true,
  setUser: () => null,
  setLoading: () => Boolean,
  gstList: () => Promise.resolve(),
}
const UserContext = createContext(defaultProvider)

const UserProvider = ({ children }) => {
  // ** States
  const [user, setUser] = useState(defaultProvider.user)
  const [loading, setLoading] = useState(defaultProvider.loading)
  const [error, setError] = useState('')

  // ** Hooks
  const navigate = useNavigate() // React Router hook for navigation

  const initAuth = async () => {
    let token = JSON.parse(localStorage.getItem("userData"))
    if (token) {
      setLoading(true)
      await axios
        .get(`${process.env.REACT_APP_BASE_URL}/gst-profile`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(async response => {
          setLoading(false)
          setUser(response.data)
        })
        .catch((error) => {
          if ((error.response && error.response.status === 403) || !token) {
            localStorage.removeItem("userData")
            navigate('/login')
          } else {
            setError('Something Went Wrong')
            setTimeout(() => {
              setError('')
            }, 3000);
          }
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (localStorage.getItem("email") && localStorage.getItem("userData")) {
      initAuth()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const values = {
    user,
    loading,
    setUser,
    setLoading,
    gstList: initAuth,
    gstError: error
  }

  return <UserContext.Provider value={values}>{children}</UserContext.Provider>
}

export { UserContext, UserProvider }
